import { type } from "os";

export interface City {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
}

// Create a schema representation of the interface
export const CitySchema = {
  name: 'City',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    code: { type: 'string' },
    state: { type: 'string' }
  }
};
